module.exports = __webpack_public_path__ + "static/quoralimitex1-ed8c59758dbd25138ef1d7c7428f6bb4.svg";